import React, { FC, useState, useRef } from 'react';
import { Avatar } from '@src/components/Avatar';
import { Button } from '@src/components/Button';
import { useAppSelector } from '@src/redux';
import { getRecruiter } from '@src/redux/selectors/recruiter';
import { CreateReplyProps } from './props';
import './styles.scss';

const TEXT_AREA_HEIGHT = 2.4;

export const CreateReply: FC<CreateReplyProps> = ({ onPost, isLoading }) => {
  const recruiter = useAppSelector(getRecruiter);

  const textAreaRef = useRef<HTMLTextAreaElement | null>(null);
  const [message, setMessage] = useState<string>('');

  const clickHandler = (): void => {
    if (textAreaRef && textAreaRef.current) {
      const { current } = textAreaRef;

      // Reset textArea styles and send message
      current.style.height = TEXT_AREA_HEIGHT + 'rem';
    }
  };

  const onChangeHandler = (updatedValue: string): void => {
    if (textAreaRef && textAreaRef.current) {
      const { current } = textAreaRef;

      current.style.height = TEXT_AREA_HEIGHT + 'rem';
      current.style.height = current.scrollHeight / 10 + 'rem';

      setMessage(updatedValue);
    }
  };

  return (
    <div className="create-reply-wrapper">
      <Avatar
        avatarColor={recruiter?.avatarColor}
        initials={recruiter?.nameInitials}
        size="large"
        source={recruiter?.avatarUrl}
      />
      <div className="create-reply-wrapper__text-container">
        <textarea
          className="create-reply-wrapper__textarea create-reply-wrapper__textarea--multiline"
          onChange={e => onChangeHandler(e.target.value)}
          onKeyDown={e => {
            // send message on enter click
            if (e.keyCode === 13 && !e.shiftKey) {
              e.preventDefault();

              clickHandler();
            }
          }}
          placeholder="Write your reply"
          ref={textAreaRef}
          style={{ height: TEXT_AREA_HEIGHT + 'rem' }}
          value={message}
        />
      </div>

      <Button
        className="empty-state__post-opening"
        isDisabled={!message.trim().length || isLoading}
        onClick={() => onPost(message)}
      >
        {isLoading ? 'Posting...' : 'Post'}
      </Button>
    </div>
  );
};
